import { applyKeyframe } from '@noths/polaris-client-styles';
import { css, keyframes } from 'styled-components';

const pulseAnimation = (from: string, to: string) => keyframes`
  0% {
    background-color: ${from};
  }

  50% {
    background-color:  ${to};
  }

  100% {
    background-color:  ${from};
  }
`;

export const pulse = css`
  background-color: var(--neutral-black-30);
  animation: ${applyKeyframe(pulseAnimation(`var(--neutral-black-30)`, `var(--neutral-black-70)`))}
    2s infinite;
`;
